// Best suited for larger loading indicators, such as full-page loading screens or large UI components (like dialogs).
export const LoadingSpinner = () => {
    return (
        <div id="preloader">
            <div className="loader"></div>
        </div>
    )
}

// Best suited for inline text loading indicators, such as in a table cell or small UI element.
export const SmallLoadingSpinner = () => {
    return (
        <div></div>
    )
}

